import React from 'react';
import { NavLink } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon, HomeIcon, UserIcon, NewspaperIcon, BriefcaseIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import Logo from '../images/logo.png';

const navigation = [
    { name: 'Home', href: '/', icon: HomeIcon },
    { name: 'About', href: '/about', icon: UserIcon },
    { name: 'Articles', href: '/articles', icon: NewspaperIcon },
    { name: 'Projects', href: '/projects', icon: BriefcaseIcon },
    { name: 'Contact', href: '/contact', icon: EnvelopeIcon },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function Nav() {
    return (
        <Disclosure as="nav" className="bg-transparent shadow-sm z-50 relative">
            {({ open }) => (
                <>
                    <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                        <div className="relative flex h-16 items-center justify-between">
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden ">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                                <div className="flex flex-shrink-0 items-center">
                                    <NavLink to="/">
                                        <img
                                            className="block h-8 w-auto lg:hidden"
                                            src={Logo}
                                            alt="kartik-binzade"
                                        />
                                        <img
                                            className="hidden h-8 w-auto lg:block"
                                            src={Logo}
                                            alt="kartik-binzade"
                                        />
                                    </NavLink>
                                </div>
                                <div className="hidden sm:ml-6 sm:block">
                                    <div className="flex space-x-4">
                                        {navigation.map((item) => (
                                            <NavLink
                                                key={item.name}
                                                to={item.href}
                                                className={({ isActive }) => classNames(
                                                    isActive ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                    'rounded-md px-3 py-2 text-sm font-medium'
                                                )}
                                            >
                                                {item.name}
                                            </NavLink>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="flex justify-around px-2 pt-2 pb-3">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    as={NavLink}
                                    to={item.href}
                                    title={item.name}
                                    className={({ isActive }) => classNames(
                                        isActive ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                        'block rounded-md p-3 text-base font-medium'
                                    )}
                                >
                                    <item.icon className="h-6 w-6" aria-hidden="true" />
                                    <span className="sr-only">{item.name}</span>
                                </Disclosure.Button>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    );
}
